import { OpenEndedTopicChart } from './components/OpenEndedTopicChart';
import { OutcomeResultsChart } from './components/OutcomeResultsChart';
import { SentimentAnalysisChart } from './components/SentimentAnalysisChart';
import { TopicDistributionChart } from './components/TopicDistributionChart';
import { useConversationAnalytics } from '@/Domain/hooks/Analytics/useConversationAnalytics.hook';
import { useConversationTopicsList } from '@/Domain/hooks/Conversation/useConversationTopicsList.hook';

type Props = {
  startDate: Date;
  endDate: Date;
};

export const ChartsSection = ({ startDate, endDate }: Props) => {
  const { data: topics, hasFilledTopic } = useConversationTopicsList();

  const {
    outcomeData,
    outcomeLabels,
    sentimentData,
    topicData,
    topicConfig,
    topicTotals,
    openEndedTopicData,
    openEndedTopicConfig,
    openEndedTopicTotals,
    isLoading: isConvLoading,
  } = useConversationAnalytics({
    startDate,
    endDate,
  });

  // Check if there are any topics configured
  const hasTopics = Boolean(topics && topics.length > 0 && hasFilledTopic);

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
      <OutcomeResultsChart
        data={outcomeData || []}
        labels={outcomeLabels}
        isLoading={isConvLoading}
      />

      <SentimentAnalysisChart data={sentimentData || []} isLoading={isConvLoading} />

      <OpenEndedTopicChart
        data={openEndedTopicData || []}
        config={openEndedTopicConfig || {}}
        totals={openEndedTopicTotals || {}}
        isLoading={isConvLoading}
      />

      <TopicDistributionChart
        data={topicData || []}
        config={topicConfig || {}}
        totals={topicTotals || {}}
        hasTopics={hasTopics}
        isLoading={isConvLoading}
      />
    </div>
  );
};
